function h(n, t) {
  const r = BigInt(n < BigInt(0) ? -1 : 1);
  return (n * r + t / BigInt(2)) / t * r;
}
function _(n) {
  let [t, r = "0"] = n.split(".");
  return t === "" && (t = "0"), r = r.replace(/(?!^)0*$/, ""), [t, r];
}
function f(n) {
  return BigInt("1" + "0".repeat(n));
}
function m(n) {
  return Array.isArray(n) && typeof n[0] == "bigint" && typeof n[1] == "number";
}
const b = /^-?(?:[0-9]+|(?:[0-9]*(?:\.[0-9]+)))$/;
function l(n, t = !0) {
  if (m(n))
    return s(n, t === !0 ? n[1] : t);
  if (n = String(n), !n.match(b))
    throw new Error(`Incorrect number: ${n}`);
  const r = n.startsWith("-");
  r && (n = n.slice(1));
  const o = _(n), e = o[0];
  let i = o[1];
  return t === !0 && (t = i === "0" ? 0 : i.length), i = i.slice(0, t), i = i + "0".repeat(t - i.length), [(BigInt(e) * f(t) + BigInt(i)) * BigInt(r ? -1 : 1), t];
}
function I(n, t, r = {}) {
  return r.round ??= !0, t > 0 ? n * f(t) : t < 0 ? r.round ? h(n, f(-t)) : n / f(-t) : n;
}
function s(n, t, r = {}) {
  if (r.round ??= !0, n[1] === t)
    return n;
  if (n[1] < 0 || t < 0)
    throw new Error("Decimals cannot be negative");
  const o = t - n[1];
  return [
    I(n[0], o, r),
    t
  ];
}
function w(n, t) {
  const r = t ?? Math.max(...n.map(([, o]) => o), 0);
  return n.map((o) => s(o, r));
}
function y([n, t]) {
  return JSON.stringify([String(n), t]);
}
function N(n) {
  const [t, r] = JSON.parse(n);
  return [BigInt(t), r];
}
function B(n, t = {}) {
  const [r, o] = n;
  typeof t == "number" && (t = { digits: t });
  const {
    digits: e = o,
    trailingZeros: i = !1
  } = t;
  if (o === 0)
    return [r, null];
  const c = f(o), g = r / c;
  let u = String(r % c).replace(/^-/, "");
  return u = "0".repeat(
    Math.max(0, String(c).length - u.length - 1)
  ) + h(
    BigInt(u),
    f(Math.max(0, o - e))
  ), i ? u = u.padEnd(e, "0") : u = u.replace(/0+$/, ""), [
    g,
    u === "" || BigInt(u) === BigInt(0) ? null : u
  ];
}
function $(n, t) {
  return Number(B(n, { digits: t }).join("."));
}
function x(n, t = {}) {
  const r = typeof t == "number" ? { digits: t } : t, [o, e] = B(n, {
    digits: r.digits,
    trailingZeros: r.trailingZeros
  }), i = r.locale ?? Intl.NumberFormat().resolvedOptions().locale, c = new Intl.NumberFormat(i).formatToParts(0.1).find((u) => u.type === "decimal")?.value ?? ".", g = o.toLocaleString(i, {
    notation: r.compact ? "compact" : "standard"
  });
  return e === null || !/\d/.test(g.at(-1)) ? g : `${g}${c}${e}`;
}
function E(n, t, r) {
  const [o, e] = a(n, t, r);
  return s(
    [o[0] + e[0], o[1]],
    r ?? (m(n) ? n[1] : o[1])
  );
}
function M(n, t, r) {
  const [o, e] = a(n, t, r);
  return s(
    [o[0] - e[0], o[1]],
    r ?? (m(n) ? n[1] : o[1])
  );
}
function p(n, t, r) {
  const [o, e] = a(n, t, r);
  return s(
    [o[0] * e[0], o[1] * 2],
    r ?? (m(n) ? n[1] : o[1])
  );
}
function z(n, t, r) {
  const [o, e] = a(n, t, r);
  if (e[0] === BigInt(0))
    throw new Error("Dnum: division by zero");
  const i = I(o[0], Math.max(o[1], r ?? 0)), c = I(e[0], 0);
  return s(
    [h(i, c), o[1]],
    r ?? (m(n) ? n[1] : o[1])
  );
}
function A(n, t) {
  const [r, o] = a(n, t);
  return r[0] === o[0];
}
function J(n, t) {
  const [r, o] = a(n, t);
  return r[0] > o[0];
}
function T(n, t) {
  const [r, o] = a(n, t);
  return r[0] < o[0];
}
function q(n, t) {
  const [r, o] = l(n);
  t === void 0 && (t = o);
  let e = r;
  return e < BigInt(0) && (e = -e), s([e, o], t);
}
function S(n, t) {
  const [r, o] = l(n);
  t === void 0 && (t = o);
  let e = BigInt(String(r).slice(0, -o));
  const i = BigInt(String(r).slice(-o));
  e < BigInt(0) && i > BigInt(0) && (e -= BigInt(1));
  const c = [
    BigInt(String(e) + "0".repeat(o)),
    o
  ];
  return s(c, t);
}
function F(n, t) {
  const r = [BigInt(-1), 0];
  return p(S(p(n, r)), r, t);
}
function P(n, t) {
  const r = l(n);
  return s(
    s(r, 0),
    t === void 0 ? r[1] : t
  );
}
function a(n, t, r) {
  const o = l(n), e = l(t);
  if (o[1] < 0 || e[1] < 0)
    throw new Error("Dnum: decimals cannot be negative");
  return w(
    [o, e],
    Math.max(o[1], e[1], r ?? 0)
  );
}
export {
  q as abs,
  E as add,
  F as ceil,
  z as div,
  z as divide,
  A as eq,
  A as equal,
  w as equalizeDecimals,
  S as floor,
  x as format,
  l as from,
  N as fromJSON,
  J as greaterThan,
  J as gt,
  m as isDnum,
  T as lessThan,
  T as lt,
  p as mul,
  p as multiply,
  P as round,
  s as setDecimals,
  M as sub,
  M as subtract,
  y as toJSON,
  $ as toNumber,
  B as toParts
};
//# sourceMappingURL=dnum.js.map
